// http://dmfrancisco.github.io/react-icons/

import React from "react"
import styled from "styled-components"
import { space, color } from "styled-system"
import { NONAME } from "dns"

const renderGraphic = icon => {
  switch (icon) {
    case "arrow":
      return (
        <path
          style={{
            transform: "translate(-4px, -3px)"
          }}
          d="M21.883 12l-7.527 6.235.644.765 9-7.521-9-7.479-.645.764 7.529 6.236h-21.884v1h21.883z"
        />
        /* <path d="M21 11H6.83l3.58-3.59L9 6l-6 6 6 6 1.41-1.41L6.83 13H21z " /> */
      )
    case "facebook":
      return (
        <g>
          <path
            style={{
              strokeWidth: 0.5,
              transform: "translate(0.25px, 0.25px)",
              stroke: "currentcolor",
              fill: "none"
            }}
            d="m19.5,19.5l0,-19.5l-19.5,0l0,19.5l6.4,0l4,0l0,-7.5l-2.5,0l0,-3l2.5,0l0,-2.2c0,-2.5 1.5,-3.9 3.8,-3.9c0.8,0 1.5,0 2.3,0.1l0,2.6l-1.5,0c-1.2,0 -1.5,0.6 -1.5,1.4l0,1.9l2.9,0l-0.4,3l-2.6,0l0,7.5l3.6,0l2.5,0l0,0.1z"
          />
        </g>
      )
    case "instagram":
      return (
        <g>
          <rect
            x="0.325072"
            y="0.325"
            width="19.5"
            height="19.5"
            strokeWidth="0.5"
            stroke="currentcolor"
            fill="none"
          />
          <path
            fill="currentcolor"
            d="m16.825072,4.425c0,0.7 -0.5,1.2 -1.2,1.2s-1.2,-0.5 -1.2,-1.2s0.5,-1.2 1.2,-1.2c0.7,0 1.2,0.5 1.2,1.2"
          />
          <path
            strokeWidth="0.5"
            fill="none"
            stroke="currentcolor"
            d="m15.025072,10.125c0,2.7 -2.2,4.9 -4.9,4.9c-2.7,0 -4.9,-2.2 -4.9,-4.9s2.2,-4.9 4.9,-4.9c2.7,0 4.9,2.2 4.9,4.9z"
          />
        </g>
      )
    default:
      return null
  }
}

const styles = size => ({
  fill: "currentcolor",
  verticalAlign: "middle",
  width: size,
  height: size
})

export default styled(({ icon, size, style, ...rest }) => (
  <svg
    viewBox="0 0 20 20"
    preserveAspectRatio="xMidYMid meet"
    style={{ ...styles(size ? size : 20), ...style }}
    {...rest}
  >
    {renderGraphic(icon)}
  </svg>
))`
  ${space};
  ${color};
`
